import React from 'react';
import { Container } from 'react-bootstrap';
import Button from '../../../components/Button/Button';
import SpousalSurchargeModal from './SpousalSurchargeModal';

const SpousalSurchargeModalDemo = () => {
  const [showSpousalSurchargeModal, setShowSpousalSurchargeModal] =
    React.useState<boolean>(false);

  const handleShowSpousalSurchargeModal = () =>
    setShowSpousalSurchargeModal(true);
  const handleCloseSpousalSurchargeModal = () =>
    setShowSpousalSurchargeModal(false);

  return (
    <Container>
      <Container className="mt-10">
        <h4>Spousal Surcharge Modal</h4>
        <Button onMouseDown={handleShowSpousalSurchargeModal}>
          Open Modal
        </Button>
        <SpousalSurchargeModal
          showSpousalSurchargeModal={showSpousalSurchargeModal}
          handleCloseSpousalSurchargeModal={handleCloseSpousalSurchargeModal}
        />
      </Container>
    </Container>
  );
};

export default SpousalSurchargeModalDemo;
